import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  UpdateInvoiceStatusActions as Actions,
  UpdateInvoiceStatusRequestAction as RequestAction,
} from 'store/ducks/pendingRelease';

export function* updateInvoiceStatusRequest(action: any) {
  const { payload, onSuccess, onFailure }: RequestAction = action;
  try {
    const { data } = yield call(api.post, `invoices/status`, payload);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
